// Who bills a cost, and where it is listed. Orders take the category of their costs.
const costCategories = {
	PRODUCTION: "production", // Billed by producers, in their finance views.
	CLOUD: "cloud", // Cloud revenues and start fees, billed from super-admin.
};

export default costCategories;
